import React from 'react';
import styles from '../styles/headerTickets.module.scss';
import { container } from 'tsyringe';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { ITicketService } from '../model/interfaces';

export const HeaderTickets = () => {
  const ticketsService: ITicketService = container.resolve('ticketsService');
  const tickets = useBehaviorSubject(ticketsService.accountBalance);

  return (
    <div className={styles.tickets}>
      <span>{`${t('tickets')}:`}</span>
      <span>{tickets || 0}</span>
    </div>
  );
};
